<template>
  <div class="topic-item" @click="goDes">
    <!-- 用户信息 -->
    <div class="user show-group">
      <div class="user-img" @click.stop="goIndex">
        <img :src="baseUserInfoVo.avatar" alt="" />
      </div>
      <div class="user-des">
        <h3 class="h3">
          <span class="name" @click.stop="goIndex">{{
            baseUserInfoVo.nickname
          }}</span>
        </h3>

        <!-- 对露出标签进行统一展示 -->
        <ExposedLabel
          :listType="1"
          :userIdentifyVoList="baseUserInfoVo.userIdentifyVoList"
          :userLevel="hasLevel"
        ></ExposedLabel>
      </div>
      <div
        class="user-btn"
        @click.stop="subscribe"
        v-if="isShowFocus && !baseUserInfoVo.subscribeStatus"
      >
        <!-- <span class="icon-jia"></span> 关注 -->
        + 关注
      </div>
    </div>
    <!-- 动态内容 -->
    <div class="topic-content">
      <!-- 新增插槽方便下次拓展 -->
      <slot name="content" :data="topic"></slot>
      <!-- @邓如冰 要求动态卡片富文本需要换行处理 -->
      <div class="content">
        <YxlMore
          :isClickShow="false"
          :lineClamp="5"
          :info="htmlDecode(dataObject.objectDesc)"
        ></YxlMore>
      </div>
      <div
        class="img-list"
        :class="{ one: dataObject.objectCovers.length === 1 }"
        v-if="dataObject.objectCovers && dataObject.objectCovers.length > 0"
      >
        <div
          class="img-item"
          v-for="(item, index) in dataObject.objectCovers.slice(0, 3)"
          :key="index"
          @click.stop="openImgViewrt(dataObject.objectCovers, index)"
        >
          <img :src="item" alt="" />
        </div>
      </div>
      <div class="video" v-if="dataObject.objectVideo">
        <div
          v-if="wechatState"
          class="wxOpenInAPP"
          :data-url="appUrl"
          @click.stop
          style="position: absolute; width: 100%; height: 100%; left: 0; top: 0"
        ></div>
        <div @click.stop="goSeeVideo()">
          <img class="video-bg" :src="dataObject.objectVideoCover" alt="" />
          <img
            class="video-play"
            src="../../../images/platform/topicDetail/icon-play.png"
            alt=""
          />
        </div>
      </div>
      <!-- 排序 群卡片 > 话题卡片 > 群任务卡片-->
      <!-- 社群卡片 -->
      <div
        v-if="dataObject.groupId && showGroupInfo"
        class="topic-card group-card"
        @click.stop="goGroupDes"
      >
        <img
          class="icon-topic"
          src="../../../images/platform/topicDetail/icon-group.png"
        />
        <span class="topic-text">{{ dataObject.groupName }}</span>
      </div>
      <!-- 话题卡片 || 群任务卡片 -->
      <div
        class="topic-card"
        :class="{ 'group-card': +dataObject.tagType === 1 }"
        v-if="isShowTopicCard"
        @click.stop="gotagPage"
      >
        <img
          v-if="+dataObject.tagType === 1"
          class="icon-topic"
          src="../../../images/platform/topicDetail/icon-tips2.png"
        />
        <img
          v-else
          class="icon-topic"
          src="../../../images/platform/topicDetail/icon-tips.png"
        />
        <span class="topic-text">{{ dataObject.tagName }}</span>
      </div>
      <!-- 关联尾巴 -->
      <Tail
        class="tail"
        :cards="dataObject.cards"
        v-if="dataObject.cards"
        @gotailurl="gotailurl"
      ></Tail>
      <!-- 发布日期 -->
      <p class="see">
        {{ dataObject.timeDescription }}
        <!-- @邓如冰 群动态&群任务的内容可见范围标签显示 需求链接：http://112.124.122.87:8084/index.php?m=story&f=view&storyID=3873 新增插槽为了不影响其他地方引入逻辑 -->
        <slot name="tips" :data="topic"></slot>
      </p>
    </div>
    <!-- 操作列表 -->
    <div class="topic-hand">
      <div
        class="hend-item"
        :class="{ 'last-child': item.type === 'report' }"
        v-for="(item, index) in handleList"
        :key="index"
        @click.stop="item.click"
      >
        <img class="icon" :src="item.icon" />
        <span class="num">{{ item.num }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import { forDate } from 'app/web/utils/index.js'
import { getEnvHost } from 'lib/tools/getPlatform'
import { htmlDecode } from 'app/web/utils/index.js'
import YxlMore from 'component/common/yxlMore.vue'
import Tail from 'component/platform/topicDetail/tail.vue'
import ExposedLabel from 'app/web/component/platform/exposedLabel.vue'

export default {
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 当前项详情
    topic: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: [Number, String],
      default: null
    },
    // 当前项索引
    index: {
      type: [Number, String],
      default: null
    },
    showGroupInfo: {
      type: Boolean,
      default: true
    },
    showTopicCard: {
      type: Boolean,
      default: true
    },
    // 是否微信浏览器
    wechatState: {
      type: Boolean,
      default: false
    },
    // 是否点击个人信息跳转到个人主页
    isGoUserIndex: {
      type: Boolean,
      default: true
    },
    // 是否显示关注按钮
    isShowFocus: {
      type: Boolean,
      default: true
    },
    // 是否显示三个点
    isShowMore: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ExposedLabel,
    YxlMore,
    Tail
  },
  data() {
    return {}
  },
  computed: {
    // 操作列表
    handleList() {
      let arr = [
        {
          type: 'share',
          icon: require('../../../images/platform/topicDetail/icon-share.png'),
          num:
            (this.contentStatisticsVo && this.contentStatisticsVo.shareNum) ||
            '分享',
          click: () => {
            this.$emit('handleClick', {
              type: 'share',
              params: this.topic,
              index: this.index
            })
          }
        },
        {
          type: 'goComment',
          icon: require('../../../images/platform/topicDetail/icon-huifu.png'),
          num:
            (this.contentStatisticsVo && this.contentStatisticsVo.commentNum) ||
            '评论',
          click: () => {
            this.goDes()
          }
        },
        {
          type: 'setLike',
          icon:
            this.contentStatisticsVo && this.contentStatisticsVo.likeState
              ? require('../../../images/platform/dynamicDetail/icon-zan-seteted.png')
              : require('../../../images/platform/topicDetail/icon-zan.png'),
          num:
            (this.contentStatisticsVo && this.contentStatisticsVo.likeNum) ||
            '赞',
          click: () => {
            this.$emit('handleClick', {
              type: 'setLike',
              params: this.topic,
              index: this.index
            })
          }
        },
        {
          type: 'report',
          icon: require('../../../images/platform/topicDetail/icon-jubao.png'),
          click: () => {
            this.$emit('handleClick', {
              type: 'report',
              params: this.topic,
              index: this.index
            })
          }
        }
      ]
      // 如果是M站,则隐藏分享功能
      if (!this.$platform.isYixinliApp) {
        const index = arr.findIndex(v => v.type === 'share')
        if (index > -1) {
          arr.splice(index, 1)
        }
      }
      arr.map((item, index) => {
        if (item.type === 'report' && !this.isShowMore) {
          arr.splice(index, 1)
        }
      })
      return arr
    },
    // 数据基础内容
    baseContentVo() {
      return this.topic.baseContentVo || {}
    },
    // 用户基础数据
    baseUserInfoVo() {
      return this.topic.baseUserInfoVo || {}
    },
    // 是否有等级
    hasLevel() {
      return this.baseUserInfoVo.userLevel?.level || {}
    },
    // 内容统计
    contentStatisticsVo() {
      return this.topic.contentStatisticsVo || {}
    },
    // 内容数据
    dataObject() {
      return this.topic.dataObject || {}
    },
    appUrl() {
      return `yixinli://open_h5?url=${Base64.encodeURI(location.href)}`
    },
    isShowTopicCard() {
      let flag =
        this.dataObject.tagId &&
        this.topic.baseContentVo.objectId != this.dataObject.tagId &&
        this.showTopicCard
      return flag
    }
  },
  created() {},
  mounted() {},
  methods: {
    forDate,
    htmlDecode,
    // 关注
    subscribe() {
      this.$emit('handleClick', {
        type: 'subscribe',
        params: this.topic,
        index: this.index,
        objectType: 10
      })
    },
    // 跳转到动态详情
    goDes() {
      this.$emit('goDes', this.topic, this.index)
    },
    goIndex() {
      // 如果不跳转首页,则跟随卡片事件
      if (this.isGoUserIndex) {
        this.routerPush(
          `${getEnvHost(
            'https://static.xinli001.com'
          )}/msite/index.html#/userIndex?id=${this.topic.baseUserInfoVo.userId}`
        )
      } else {
        this.goDes()
      }
    },
    openImgViewrt(data, index) {
      this.$emit('openImgViewrt', data, index, this.topic)
    },
    // 跳转到视频详情
    goSeeVideo() {
      this.$emit('seeVideo', this.topic)
      this.$trackEvent('feed_topic_details_operation', {
        operation_type: '查看视频',
        topic_id: this.topic.dataObject.topicId || '',
        dynamic_id: this.topic.baseContentVo.objectId || ''
      })
      this.routerPush(
        `yixinli://open_dynamic_play?id=${
          this.topic.baseContentVo.objectId
        }&other_object_id=${0}`
      )
    },
    len(val) {
      if (!val) return val
      return val.length > 6 ? Array.from(val).slice(0, 6).join('') + '...' : val
    },
    // 跳转群组主页
    goGroupDes() {
      this.$emit('goGroupDes')
      this.routerPushWithoutNav(
        `/appCommunity/groupIndex/${this.dataObject.groupId}?node=1`
      )
    },
    gotagPage() {
      this.$emit('toTagPage', this.topic)
      if (+this.dataObject.tagType === 1) {
        this.$emit('goTopicDetail')
        this.routerPush(`/topicDetail/${this.dataObject.tagId}?node=1`)
      } else if (+this.dataObject.tagType === 2) {
        this.routerPush(
          `/appCommunity/groupTaskDetail/${this.dataObject.tagId}?node=1`
        )
      }
    },
    // 点击关联卡片的前置操作（目前用做埋点
    gotailurl() {
      this.$emit('toTagPage', 'tail', this.dataObject.cards)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .exposed-label {
  margin-top: 6px !important;
}

.topic-item {
  position: relative;
  width: 686px;
  margin: 0 auto 30px;
  padding-bottom: 30px;
  background: #ffffff;
  // box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.03);
  box-shadow: 0px 0px 40px 0px #ebefff, 0px 0px 40px 0px rgba(0, 0, 0, 0.03);
  border-radius: 30px;
  box-sizing: border-box;
  // background: url('../../../images/platform/topicDetail/card-bg.png') no-repeat
  //   top/100% 252px;
  .see {
    display: flex;
    justify-items: center;
    margin-top: 26px;
    font-size: 26px;
    font-weight: 400;
    color: #9da3ac;
    line-height: 26px;
  }
  .group {
    display: inline-flex;
    align-items: center;
    height: 50px;
    padding: 0 30px;
    background: linear-gradient(
      270deg,
      rgba($color: #a2b8fd, $alpha: 0.8) 0%,
      rgba($color: #6982fa, $alpha: 0.8) 100%
    );
    box-shadow: 0px 0px 40px 0px #ebefff;
    border-radius: 30px 0px 30px 0px;
    .group-text {
      display: inline-block;
      max-width: 240px;
      font-size: 24px;
      color: #fff;
      line-height: 50px;
      text-shadow: 0px 0px 40px #ebefff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .icon-right {
      display: inline-block;
      width: 13px;
      height: 50px;
      margin-left: 10px;
      background: url('../../../images/platform/topicDetail/icon-right.png')
        no-repeat center/100% 14px;
    }
  }
  .user {
    display: flex;
    align-items: center;
    padding: 30px;
    &.show-group {
      padding-top: 20px;
    }
    .user-img {
      > img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .user-des {
      width: 420px;
      margin-left: 20px;
      .user-btns-wrap {
        margin-top: 6px;
        overflow: hidden;
      }
      .user-btns-inner {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: -10px;
      }
      .user-btn-base {
        margin-bottom: 10px;
      }
      .user-level {
        height: 36px;
        padding: 0 10px 0 7px;
        background: #f0f2ff;
        border-radius: 20px;
        font-size: 20px;
        font-weight: 400;
        color: #6982fa;
        line-height: 36px;
        display: flex;
        align-items: center;
        margin-right: 10px;
        white-space: nowrap;
        img {
          width: 34px;
          height: 34px;
          object-fit: cover;
          margin-right: 4px;
        }
      }
      .h3 {
        display: flex;
        align-items: center;
        font-size: 28px;
        font-weight: 600;
        color: #21252d;
        width: 400px;
        .name {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 10px;
        }
        > img {
          margin-left: 20px;
          width: 40px;
          height: 33px;
          object-fit: cover;
        }
      }
      .user-identify {
        display: flex;
        align-items: center;
        padding: 3px 12px;
        margin-right: 10px;
        background: #fff1ee;
        border-radius: 20px;
        box-sizing: border-box;
        white-space: nowrap;
        > img {
          width: 40px;
          height: 33px;
        }
        .identify-name {
          font-size: 20px;
          margin-left: 4px;
          color: #ff745b;
          font-weight: normal;
        }
      }
    }
    .user-btn {
      position: absolute;
      top: 30px;
      right: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 115px;
      height: 53px;
      background: linear-gradient(225deg, #869bff 0%, #627dff 100%);
      box-shadow: 0px 0px 40px 0px #ebefff;
      border-radius: 27px;
      font-size: 26px;
      font-weight: 500;
      color: #fff;
      line-height: 1;
      text-shadow: 0px 0px 40px #ebefff;
      // .icon-jia {
      //   display: inline-block;
      //   margin-right: 4px;
      //   width: 14px;
      //   height: 14px;
      //   background: url('../../../images/platform/topicDetail/icon-jia.png')
      //     center/100% 100%;
      // }
    }
  }
  .topic-content {
    padding: 0 30px;
    .content {
      font-size: 30px;
      color: #6c798c;
      line-height: 49px;
      text-shadow: 0px 0px 40px #ebefff;
    }
    .img-list {
      margin-top: 20px;
      display: flex;
      .img-item {
        width: 192px;
        height: 192px;
        &:not(:last-child) {
          margin-right: 25px;
        }
        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }
      }
      &.one {
        .img-item {
          width: 300px;
          height: 300px;
          > img {
            border-radius: 16px;
          }
        }
      }
    }
    .video {
      position: relative;
      margin-top: 20px;
      width: 341px;
      height: 192px;
      border-radius: 10px;
      .video-bg {
        width: 341px;
        height: 192px;
        object-fit: cover;
        border-radius: 10px;
      }
      .video-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
      }
    }
  }
  .topic-card {
    display: inline-flex;
    align-items: center;
    padding: 13px;
    margin-top: 30px;
    background: rgba($color: #ffa202, $alpha: 0.1);
    border-radius: 25px;
    .icon-topic {
      float: left;
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .topic-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 560px;
      display: inline-block;
      font-size: 24px;
      color: #ffa202;
      text-shadow: 0px 0px 40px #ebefff;
      line-height: 1;
      vertical-align: -10%;
    }
    &.group-card {
      background: linear-gradient(
        90deg,
        rgba($color: #a2b8fd, $alpha: 0.1) 0%,
        rgba($color: #6982fa, $alpha: 0.1) 100%
      );
      .topic-text {
        color: #6982fa;
      }
    }
  }
  .topic-hand {
    padding: 0 30px;
    margin-top: 30px;
    display: flex;
    .hend-item {
      // flex: 1;
      display: flex;
      align-items: center;
      .icon {
        width: 36px;
        height: 36px;
        margin-right: 10px;
      }
      .num {
        font-size: 24px;
        font-weight: 400;
        color: #9da3ac;
        line-height: 24px;
      }
      &:not(:first-child) {
        margin-left: 100px;
      }
      &.last-child {
        margin-left: auto;
      }
    }
  }
  .tail {
    margin-top: 30px;
  }
  .wxOpenInAPP {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 2;
  }
}
</style>
<style lang="scss">
.topic-item {
  .more-height {
    .more-content-text {
      font-size: 28px;
    }
  }
}
</style>
